module.exports = __webpack_public_path__ + "static/media/h240_3.83db920cab2a720103f6a45a2b62f7dc.png";